import React from 'react';
import './Vision.css';
import { getVisionContent } from '../utils/contentLoader';

function Vision() {
  return (
    <section id="vision" className="vision">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">{getVisionContent().title || "My Vision"}</h2>
          <div className="section-divider"></div>
        </div>

        <div className="vision-content">
          <div className="vision-main-wrapper">
            <div className="vision-main">
              <h3 className="vision-heading">
                {getVisionContent().heading || "Crypto Can Make the World a Better Place"}
              </h3>
              {getVisionContent().paragraphs?.map((paragraph, index) => (
                <p key={index} className="vision-text">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Vision;
